import type { DocMigration } from "../docMigration";

const WALLS = "WALLS";
const WALL_ASSEMBLIES = "WALL_ASSEMBLIES";

const WALL_CORE = "WALL_CORE";
const WALL_SUBSTRATE = "WALL_SUBSTRATE";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_383: DocMigration = {
  maxSchemaVersion: "0.0.383",
  description: "Migrate plan views to use new wall categories",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      let addWallCategories = false;
      if (viewTemplate.categories.includes(WALLS)) {
        viewTemplate.categories.splice(viewTemplate.categories.indexOf(WALLS), 1);
        addWallCategories = true;
      }

      let addWallAssemblyCategories = false;
      if (viewTemplate.categories.includes(WALL_ASSEMBLIES)) {
        viewTemplate.categories.splice(viewTemplate.categories.indexOf(WALL_ASSEMBLIES), 1);
        addWallAssemblyCategories = true;
      }

      if (viewTemplate.styleOverrides) {
        const wallOverride = viewTemplate.styleOverrides[WALLS];
        if (wallOverride) {
          delete viewTemplate.styleOverrides[WALLS];
          viewTemplate.styleOverrides[WALL_CORE] = wallOverride;
        }

        const wallAssemblyOverride = viewTemplate.styleOverrides[WALL_ASSEMBLIES];
        if (wallAssemblyOverride) {
          delete viewTemplate.styleOverrides[WALL_ASSEMBLIES];
          viewTemplate.styleOverrides[WALL_SUBSTRATE] = wallAssemblyOverride;
        }
      }

      if (addWallCategories) {
        viewTemplate.categories.push(WALL_CORE);
      }
      if (addWallAssemblyCategories) {
        viewTemplate.categories.push(WALL_SUBSTRATE);
      }
    }
    return json;
  },
};

export default migration_0_0_383;
